import React, { useEffect, useState } from "react";
import Permission from "./Permission";
import {
    getAllAdmins,
    adminPermission,
    deleteAdmin,
    addNewAdmin, addAdminPhoneNumber, editAdminPhone,
} from "../../api/methods";
import Loading from "../../components/shared/Loading";
import {showToast} from "../../helpers/showToast";

const PermissionControlContainer = ({ tab, ...Props }) => {
  const [loader, setLoader] = useState(false);
  const [response, setResponse] = useState([]);
  const [admins, setAdminsData] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [loading, setLoading] = useState({});

  const [search, setSearch] = useState({
    username: "",
    id: "",
  });

  const onAddAdmin = (adminData) => {
    const usernameWithPrefix = `Dashboard_${adminData.username}`;
    const adminDataWithPrefix = { ...adminData, username: usernameWithPrefix };
    setLoader(true);

    addNewAdmin(adminDataWithPrefix)
      .then((response) => {
        setAdminsData((prevAdmins) => [...prevAdmins, response]);
        showToast({
          toastOptions: {type: "success",}, data: {
            variant: 'success', text: "Admin added successfully",
          },
        });
      })
      .catch((error) => {
        const errorMessage = error?.error || "Failed to add new admin. Please try again later.";
        console.error("add new admin error:", errorMessage);
        showToast({
          toastOptions: { type: 'error' }, data: {
            variant: 'error', text: errorMessage,
          },
        });
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const handelGetAllAdmins = () => {
    setLoader(true);
    getAllAdmins({ page: activePage, ...search })
      .then((response) => {
        setLoader(false);
        setResponse(response);
        setAdminsData(response.listOfAdmins);
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
      });
  };
  useEffect(() => {
    handelGetAllAdmins(activePage);
  }, [activePage, search]);

  const onChangePageHandler = (pageValue) => {
    setActivePage(pageValue);
  };

  const handleStatusChange = (newValue, rowData) => {
    setLoading((prevState) => ({
      ...prevState,
      [rowData.status]: true,
    }));

    const dataObject = {
      status: newValue,
    };
    adminPermission(rowData.id, dataObject)
      .then(() => {
        const updatedadmins = admins.map((admin) => {
          if (admin.id === rowData.id) {
            return { ...admin, status: newValue };
          }
          return admin;
        });

        setLoading((prevState) => ({
          ...prevState,
          [rowData.status]: false,
        }));
        setAdminsData(updatedadmins);
      })
      .catch(() => {
        setLoading((prevState) => ({
          ...prevState,
          [rowData.status]: false,
        }));
      });
  };

  const onSearchHandler = (searchValue) => {
    if (searchValue) {
      const containsNonNumeric = /[^\d]/.test(searchValue);
      setSearch({
        username: containsNonNumeric ? searchValue : "",
        id: containsNonNumeric ? "" : searchValue,
      });
    } else {
      setSearch({
        username: "",
        id: "",
      });
    }
  };

  const handleDeleteAdmin = (adminData) => {
    deleteAdmin(adminData.id)
      .then(() => {
        const updatedAdmins = admins.filter(
          (admin) => admin.id !== adminData.id
        );
        setAdminsData(updatedAdmins);
      })
      .catch((error) => {
        console.error("Error deleting user:", error);
      });
  };

  const editAdminPhoneNumber = (adminData) => {
      const payload = {
          "userName": adminData.username,
          "newPhoneNumber": adminData.phoneNumber
      };
      console.log("Admin Data received:", adminData);
      console.log("Payload being sent:", payload);

      editAdminPhone(payload)
      .then(() => {
          handelGetAllAdmins();
          showToast({
            toastOptions: {type: "success",}, data: {
              variant: 'success', text: "Phone number updated successfully",
            },
          });
      })
      .catch((error) => {
        const errorMessage = error?.error || "Failed to update phone number. Please try again.";
        console.error("Error updating phone number:", error);
        showToast({
          toastOptions: { type: 'error' }, data: {
            variant: 'error', text: errorMessage,
          },
        });
      });
  };

  return (
    <React.Fragment>
      {loader && <Loading />}
      {response && (
        <Permission
          tab={tab}
          onAddAdmin={onAddAdmin}
          admins={admins}
          response={response}
          handleStatusChange={handleStatusChange}
          onChangePageHandler={onChangePageHandler}
          onSearchHandler={onSearchHandler}
          loading={loading}
          onDeleteClick={handleDeleteAdmin}
          editAdminPhoneNumber={editAdminPhoneNumber}
        />
      )}
    </React.Fragment>
  );
};

export default React.memo(PermissionControlContainer);
